import ListPasses from './ListPasses';
import ViewPass from './ViewPass';
import PreviewPass from './PreviewPass';

window.Vue.component('PartnerListPasses', ListPasses);
window.Vue.component('PartnerViewPass', ViewPass);
window.Vue.component('PartnerPreviewPass', PreviewPass);